import type { Categoria } from '../types/himno';

export const CATEGORIAS: Categoria[] = [
  {
    titulo: '1. Glorificar a Dios',
    grupos: [
      { titulo: '1.1 Glorificar a Dios', inicio: 1, fin: 8 },
      { titulo: '1.2 La biblia... nuestra regla', inicio: 9, fin: 21 },
    ]
  },
  {
    titulo: '1.3 Dios, su majestad y gloria',
    grupos: [
      { titulo: 'La Trinidad', inicio: 21, fin: 32 },
      { titulo: 'El Padre, sus perfecciones', inicio: 33, fin: 59 },
      { titulo: 'Sus decretos', inicio: 60, fin: 73 },
      { titulo: 'Sus obras', inicio: 74, fin: 88 },
    ]
  },
  {
    titulo: '1.4 El hombre, su condición',
    grupos: [
      { titulo: 'El hombre, su condición', inicio: 89, fin: 105 },
    ]
  },
  {
    titulo: '1.5 Jesucristo',
    grupos: [
      { titulo: 'Su venida', inicio: 106, fin: 140 },
    ]
  },
  {
    titulo: 'Su ministerio mediatorio',
    grupos: [
      { titulo: 'Profeta', inicio: 141, fin: 152 },
      { titulo: 'Sacerdote', inicio: 153, fin: 173 },
      { titulo: 'Rey', inicio: 174, fin: 236 },
      { titulo: 'Su gracia y redención', inicio: 237, fin: 260 },
    ]
  },
  {
    titulo: '2. Gozar de Él para siempre',
    grupos: [
      { titulo: '2.1 El Espíritu Santo', inicio: 261, fin: 276 },
    ]
  },
  {
    titulo: '2.2 La vida en Cristo',
    grupos: [
      { titulo: '- Nacer en Cristo', inicio: 277, fin: 296 },
      { titulo: 'Bautismo y profesión de fe', inicio: 297, fin: 312 },
      { titulo: '- Crecer en Cristo', inicio: 313, fin: 332 },
      { titulo: 'En santidad', inicio: 333, fin: 345 },
      { titulo: 'En sabiduría: conocimiento de Dios', inicio: 346, fin: 362 },
      { titulo: 'En poder: pruebas, vida cristiana', inicio: 363, fin: 382 },
      { titulo: 'En gozo: gratitud', inicio: 383, fin: 398 },
    ]
  },
  {
    titulo: '2.3 La comunión con Cristo',
    grupos: [
      { titulo: '- La iglesia', inicio: 399, fin: 407 },
      { titulo: 'Su culto: apertura, bienvenida, doxologías, ofrendas y diezmos, clausura y bendición', inicio: 408, fin: 455 },
      { titulo: 'Su eucaristía: Santa Cena', inicio: 456, fin: 465 },
      { titulo: 'Su renovación: avivamiento', inicio: 466, fin: 474 },
      { titulo: 'Sus organizaciones y celebraciones', inicio: 475, fin: 509 },
      { titulo: '- La oración', inicio: 510, fin: 525 },
      { titulo: '- La consagración', inicio: 526, fin: 545 },
    ]
  },
  {
    titulo: '2.4 El servicio para Cristo',
    grupos: [
      { titulo: '- En el hogar', inicio: 546, fin: 552 },
      { titulo: 'Sus bendiciones', inicio: 553, fin: 574 },
      { titulo: 'Sus actividades: culto familiar, alimentos', inicio: 575, fin: 583 },
      { titulo: '- En la sociedad', inicio: 584, fin: 599 },
      { titulo: 'Misiones', inicio: 600, fin: 621 },
      { titulo: 'Patriotismo y responsabilidad social', inicio: 622, fin: 638 },
      { titulo: '- En gloria', inicio: 639, fin: 655 },
    ]
  },
  {
    titulo: '3. Salmos',
    grupos: [
      { titulo: 'Salmos', inicio: 656, fin: 706 },
    ]
  }
];
